export default {"src":"/_next/static/media/bubble.2f65cd61.svg","height":108,"width":324};